import React from 'react';
import C from './colors';
import { formatMoney, multiplyMoney } from '../../money';

function getSelectionQuotaProgress(selectedCount, selectionLimit) {
    const selected = Math.max(0, Number(selectedCount) || 0);
    const limit = Math.max(0, Number(selectionLimit) || 0);
    const included = Math.min(selected, limit);
    const extra = Math.max(0, selected - limit);
    const scale = Math.max(selected, limit);

    return {
        selected,
        limit,
        included,
        extra,
        includedPercent: scale > 0 ? included / scale * 100 : 0,
        extraPercent: scale > 0 ? extra / scale * 100 : 0,
    };
}

export default function SelectionQuotaProgress({
    selectedCount,
    selectionLimit,
    hasPackage,
    forceLimit,
    pricePerPic,
}) {
    const quota = getSelectionQuotaProgress(selectedCount, selectionLimit);
    const unitPrice = Math.max(0, Number(pricePerPic) || 0);
    const extraCost = multiplyMoney(quota.extra, unitPrice);

    return (
        <div data-testid="customer-selection-progress" style={{ marginTop: 15 }}>
            <div style={{ position: 'relative', height: 5, background: C.hair, borderRadius: 3, overflow: 'hidden' }}>
                <div
                    data-testid="customer-selection-included-progress"
                    style={{
                        position: 'absolute', left: 0, top: 0, bottom: 0,
                        width: `${quota.includedPercent}%`, background: C.ink,
                        borderRadius: 3, transition: 'width .25s',
                    }}
                />
                {quota.extra > 0 && (
                    <div
                        data-testid="customer-selection-extra-progress"
                        style={{
                            position: 'absolute', left: `${quota.includedPercent}%`, top: 0, bottom: 0,
                            width: `${quota.extraPercent}%`, background: C.brand,
                            borderRadius: '0 3px 3px 0', transition: 'left .25s, width .25s',
                        }}
                    />
                )}
            </div>

            <div style={{
                marginTop: 7, display: 'flex', justifyContent: 'space-between', gap: 12,
                fontFamily: C.mono, fontSize: 10, color: C.ink3,
            }}>
                {hasPackage ? (
                    <>
                        <span>套餐内 {quota.included}/{quota.limit}</span>
                        {quota.extra > 0
                            ? <span style={{ color: C.brand2 }}>加片 {quota.extra}</span>
                            : <span>· 在套餐内 ·</span>}
                    </>
                ) : forceLimit ? (
                    <>
                        <span>已选 {quota.selected}/{quota.limit}</span>
                        <span>最多可选 {quota.limit} 张</span>
                    </>
                ) : (
                    <>
                        <span>已选 {quota.selected} 张</span>
                        {quota.extra > 0
                            ? <span style={{ color: C.brand2 }}>已超选 {quota.extra} 张</span>
                            : <span>可选 {quota.limit} 张</span>}
                    </>
                )}
            </div>

            {!forceLimit && quota.extra > 0 && (
                <div data-testid="customer-extra-price-calculation" style={{
                    minHeight: 28, marginTop: 5, padding: '5px 8px', borderRadius: 6,
                    background: '#FFF2F8', display: 'flex', alignItems: 'baseline',
                    justifyContent: 'flex-end', gap: 7, boxSizing: 'border-box',
                    fontFamily: C.mono, fontSize: 10,
                }}>
                    <span style={{ flex: 1, color: C.ink3, textAlign: 'right' }}>
                        {quota.extra} × ¥{formatMoney(unitPrice)}
                    </span>
                    <span style={{ color: '#C6A0B3' }}>=</span>
                    <span style={{ color: C.brand2, fontWeight: 500, fontVariantNumeric: 'tabular-nums' }}>
                        ¥{formatMoney(extraCost)}
                    </span>
                </div>
            )}
        </div>
    );
}

export { getSelectionQuotaProgress };
